import React from 'react'
import {Icon} from '@chakra-ui/react'

const AccountIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11ZM12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                fill="currentColor"
                d="M23 22C23 23.5519 19.98 23.7555 12.0002 23.7573C4.02199 23.7592 1 23.556 1 22C1 16.4523 5.94699 12 12 12C18.053 12 23 16.4523 23 22ZM12 14C7.25702 14 3.4033 17.2549 3.02969 21.3471C3.52163 21.4324 4.25842 21.5088 5.19209 21.5716C6.98919 21.6924 9.44107 21.7579 11.9998 21.7573C14.5559 21.7567 17.0089 21.6902 18.8078 21.569C19.7413 21.506 20.4783 21.4298 20.9701 21.3448C20.5953 17.2537 16.7421 14 12 14Z"
            />
        </Icon>
    )
}

export default AccountIcon
